import { render, staticRenderFns } from "./specialTestRecordList.vue?vue&type=template&id=45a097c4"
import script from "./specialTestRecordList.vue?vue&type=script&lang=js"
export * from "./specialTestRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports